import { CHANNEL_SEARCH_MIN_QUERY_LENGTH } from "./channel-search.shared";

/**
 * AX11 — what the live region says as the result set moves: the typing hint at
 * one character, the no-match message when nothing matched, and the count
 * otherwise.
 *
 * A pure function, so the announcement can be asserted without rendering and
 * the client twin does not grow a third branch of its own.
 */
export function channelSearchStatus({
  query,
  matchCount,
  typingHint,
  emptyMessage
}: {
  query: string;
  matchCount: number;
  typingHint: string;
  emptyMessage: string;
}): string {
  const term = query.trim();
  if (term.length === 0) {
    return "";
  }
  if (term.length < CHANNEL_SEARCH_MIN_QUERY_LENGTH) {
    return typingHint;
  }
  if (matchCount === 0) {
    return emptyMessage;
  }
  /* Singular at one: this is the one string in the component only
     screen-reader readers ever hear, which is the worst place to leave
     "1 suggestions". */
  return matchCount === 1 ?
    "1 suggestion available." :
    `${matchCount} suggestions available.`;
}
